// ble-client.token.ts
import { InjectionToken } from '@angular/core';
import { IBleClient } from './IBleClient';

export const BLE_CLIENT = new InjectionToken<IBleClient>('BLE_CLIENT');
